import { css } from "@emotion/react";

const alertBaseCss = css`
  position: relative;
  border: 1px solid;
  padding: 0.375rem 1rem 0.375rem 2rem;
  border-radius: 0.5rem;
`;

const alertInfoCss = [
  alertBaseCss,
  css`
    border-color: #caf9ff;
    background-color: #e5f6fd;
    color: #1d4758;
  `,
];

const alertErrorCss = [
  alertBaseCss,
  css`
    border-color: #ffa2a2;
    background-color: #fdeded;
    color: #5f2120;
  `,
];

const ALERT_DICTIONARY = {
  error: alertErrorCss,
  info: alertInfoCss,
};

export function alertCss({ type }) {
  return ALERT_DICTIONARY[type] ?? alertErrorCss;
}

export const headerCss = css`
  margin: 0.2rem 0;
`;

export const iconCss = css`
  position: absolute;
  top: 0.375rem;
  left: 0.375rem;
`;

export const textCss = css`
  display: none;
  margin: 0.1rem 0;

  &:not(:empty) {
    display: block;
  }
`;
